import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ServiceCRUD } from '../../../../shared/crud/ServiceCRUD';

@Injectable()
export class RelatorioCoafService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);
  valorModal$ = this.valorRecebido.asObservable();

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return `${this.baseUrlService}/relatorio_coaf/listar`;
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    grupo_economico?: any,
    valor?: any
  ): Observable<any> {
    let params = new HttpParams();

    if (data_inicial) params = params.set('data_inicial', data_inicial.toString());
    if (data_final) params = params.set('data_final', data_final.toString());
    if (dealers) params = params.set('dealers', dealers.toString());
    if (grupo_economico) params = params.set('grupo_economico', grupo_economico.toString());
    if (valor) params = params.set('valor', valor.toString());

    return this.httpClient.get<any>(`${this.baseUrlService + '/relatorio_coaf/listar'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: params
    });
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event)
  }

  receberValorModal() {
    return this.valorRecebido.getValue()
  }
}
